module.exports = __webpack_public_path__ + "img/cg_ruoyi_hanfu.67412b21.jpg";